import type { FC, PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

import { usePortal } from '#src/hooks/usePortal.tsx';

export const Portal: FC<
  PropsWithChildren<{
    id:
      | 'dropdown'
      | 'above-bottom-bar-portal'
      | 'above-compose-footer-portal'
      | 'page-header-title'
      | 'page-header-title-breadcrumb'
      | 'page-header-second-row'
      | 'sidebar-layout-toolbar'
      | 'page-header-right-button'
      | 'full-screen-animation'
      | 'pro-competitions-filters'
      | 'pro-games-filters'
      | 'snackbar'
      | 'onboarding-overlay'
      | 'loan-lineup-footer'
      | 'contender-drawer-content-sticky-footer'
      /* portal to insert a background that on mobile goes behind the floating header
       * and on desktop goes on the right side of the screen */
      | 'page-background';
    style?: Partial<CSSStyleDeclaration>;
  }>
> = ({ id, style, children }) => {
  const target = usePortal(id, {
    replace: id === 'page-header-title',
    style,
  });
  return createPortal(children, target);
};
